import { LitElement, html } from 'lit';
import { customElement, property, state, query } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import { resetAll } from '../../store/composition/composition.js';
import { translate } from '../../helpers/translate.js';
import '@sdb-develop/learning-frontend';
import '../shared/sdb-player-dialog.js';

@customElement('sdb-composition-reset-all-button')
class SdbCompositionResetAllButton extends connect(store)(LitElement)
 {

    @property({ type: String })
    accessor targetId;

    @property({ type: String })
    accessor compositionId;

    @property({ type: String })
    accessor compositionName;

    @property({ type: Object })
    accessor idStrings;

    @property({ type: String })
    accessor label;

    @property({ type: Boolean })
    accessor disabled = false;

    @state()
    accessor isLoading;

    @state()
    accessor resetAll;

    @query('#sdb_composition_reset_all_dialog')
    accessor resetAllDialog;

    get buttonLabel() {
        return this.label || translate('btnResetAll');
    }

    stateChanged(state) {
        this.isLoading = state.composition.status === 'loading';
        this.resetAll = state.composition.resetAll;
    }

    render() {
        if (this.isLoading) {
            return html`
                <sdb-content-button
                    label=${this.buttonLabel}
                    disabled>
                </sdb-content-button>
            `;
        }

        return html`
            <sdb-content-button
                label=${this.buttonLabel}
                ?outlined=${!this.disabled}
                ?disabled=${this.disabled}
                @click=${() => { this.resetAllDialog.open(); }}>
            </sdb-content-button>
            <sdb-player-dialog
                id="sdb_composition_reset_all_dialog"
                type="confirm"
                heading=${translate('dlgResetAllHeader')}
                body=${translate('dlgResetAllBody', { catalogName: this.catalogName })}
                confirmCaption=${translate('btnResetAll')}
                @confirm=${(e) => { this._executeReset(e); }}>
            </sdb-player-dialog>
        `;
    }

    updated(changes) {
        if (changes.has('resetAll') && this.resetAll === true) {
            this.dispatchEvent(
                new CustomEvent('resetAllCompleted', {
                    bubbles: true,
                    composed: true,
                })
            );
        }
    }

    async _executeReset(e) {
        this.dispatchEvent(
            new CustomEvent('resetAllStart', {
                bubbles: true,
                composed: true,
                target: e.target,
            })
        );

        let idStrings;
        try {
            idStrings = typeof this.idStrings === 'function'
            ? await this.idStrings()
            : this.idStrings;
        } catch (err) {
            console.error('Error loading idStrings:', err);
            // avoid hanging the UI—just close the dialog and abort
            this.dispatchEvent(new CustomEvent('resetAllCompleted'));
            return;
        }

        store.dispatch(resetAll({
            compositionId: this.compositionId,
            idStrings
        }));
    }
}
